import m from "mithril";
import {SvgIcon} from './MaterialDesignComponents'

var SpinnerBoxComponent = {
    oninit : function(vnode) {
        vnode.state.count = vnode.attrs.initialValue;
    },    
    view: function (vnode) {
        const {placeholder, singularLabel, pluralLabel, minCount, maxCount, onCountChange} = vnode.attrs;

        const label = (vnode.state.count > 1)? pluralLabel : singularLabel;

        let clickableClass = (condition, className) => {
            return (condition)? className : ""
        }

        const canIncrease = vnode.state.count < maxCount;
        const canDecrease = vnode.state.count > 1;

        return [
            m("div", {class:"border rounded shadow-sm d-flex align-items-center bg-white"}, 
                [                
                    m("div", {
                            class:"text-center",
                            onclick: function(event) {
                                event.preventDefault();
                                if(vnode.state.count > minCount){
                                    vnode.state.count -= 1;
                                    onCountChange(vnode.state.count);
                                }  
                            }
                        }, 
                        m("div", {class:"text-center py-2 px-3 " + clickableClass(canDecrease, "clickable")},
                            m("i.bi bi-dash-lg", {class: (vnode.state.count <= 1)? " text-muted" : " text-primary"})
                        )
                    ),
        
                    m("div", {class:"flex-fill text-center border-left border-right"},
                        m("div.p-2", vnode.state.count + " - " + label)
                    ),
        
                    m("div", {
                            
                            onclick: function(event) {
                                event.preventDefault();
                                if(vnode.state.count < maxCount) {
                                    vnode.state.count += 1;
                                    vnode.attrs.onCountChange(vnode.state.count);
                                } 
                            }
                        }, 
                        m("div", {class:"text-center py-2 px-3 " + clickableClass(canIncrease, "clickable")},
                            m("i.bi bi-plus-lg", {class: (vnode.state.count >= maxCount)? " text-muted" : " text-primary"})  
                        )
                    ) 
                ]            
            )
        ]        
    }
}

export default SpinnerBoxComponent;